module.exports = __webpack_public_path__ + "img/none.82f88015.png";